import { ref } from 'vue'
import { defineStore } from 'pinia'

export const usePrivacyStore = defineStore('privacy', () => {
  const currentPrivacyMode = ref(localStorage.getItem('privacy') || 'no')

  function setPrivacyMode(mode: string) {
    currentPrivacyMode.value = mode
    localStorage.setItem('privacy', mode)
  }

  return {
    currentPrivacyMode,
    setPrivacyMode
  }
})
